import React from "react";
import {useTranslation} from "react-i18next";
// local
import Upload from "components/Upload";

const OverviewManualCardView = ({
  validDate,
  sinceDate,
  meets,
  firstParameter,
  secondParameter,
  files,
}) => {
  const {t} = useTranslation();

  return (
    <div className="insurance-card">
      <p className="insurance-card__first-parameter __manual-data">{t(firstParameter)}</p>
      {secondParameter && (
        <p className="insurance-card__second-parameter __manual-data">
          {t(secondParameter)}
        </p>
      )}
      {validDate && (
        <p className="insurance-card__data __manual-data">
          <span>{t("VALID_TIL")}:</span> {validDate}
        </p>
      )}
      {sinceDate && (
        <p className="insurance-card__data __manual-data">
          <span>{t("SINCE")}:</span> {sinceDate}
        </p>
      )}
      {meets && (
        <p className="insurance-card__meets __manual-data">
          <span>{t("MEETS")}:</span>{" "}
          {meets
            .filter((item) => Object.values(item)[0])
            .map((item) => Object.keys(item)[0])
            .join(", ")}
        </p>
      )}

      {!!files?.length && (
        <Upload
          variant="overview"
          viewMode
          files={files}
          fileListClass="df-row-center pl-0"
          filenameMaxViewLength={{view: 10}}
        />
      )}
    </div>
  );
};

export default OverviewManualCardView;
